import { render } from "./IndexBtn.vue?vue&type=template&id=64d5c60d&scoped=true"
import script from "./IndexBtn.vue?vue&type=script&lang=js"
export * from "./IndexBtn.vue?vue&type=script&lang=js"

import "./IndexBtn.vue?vue&type=style&index=0&id=64d5c60d&lang=scss&scoped=true"

import exportComponent from "E:\\xlckj\\大屏\\monitor\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d5c60d"]])

export default __exports__